export default class BackgroundColourFill extends Phaser.Graphics {
  constructor({ game, colour, alpha, blockInput = true }) {
    super(game);

    this.beginFill(colour, alpha);
    this.drawRect(0, 0, this.game.defaultWidth, this.game.defaultHeight);

    this.inputEnabled = blockInput;
  }
}
